module.exports = __webpack_public_path__ + "static/media/Construction.6fa3bd4f.mp3";